import React, { useState, useCallback } from "react";
import { useSelector } from "react-redux";
import useFetch from "../../../hooks/useFetch";

/**
 * Drop-in hook for any game's game-over screen.
 * gameKey: "crashlanes" | "alienswarm" (matches each game's route prefix)
 */
export default function useScoreSubmit(gameKey) {
  const authState = useSelector((state) => state.authReducer);
  const [fetchData] = useFetch();
  const userId = authState?.user?._id;
  const userCode = authState?.user?.think5whyscode;
  const userName = authState?.user?.name;
  const token = authState?.token;

  const [submitting, setSubmitting] = useState(false);
  const [isNewRecord, setIsNewRecord] = useState(false);
  const [leaderboard, setLeaderboard] = useState([]);
  const [loadingLeaderboard, setLoadingLeaderboard] = useState(false);

  const submitScore = useCallback(
    async ({ score, timeTakenSec, levelReached }) => {
      if (!userId) return;
      setSubmitting(true);
      try {
        const res = await fetchData(
          {
            url: `/${gameKey}/save-score`,
            method: "post",
            data: { userId, userCode, userName, score, timeTakenSec, levelReached },
            headers: { Authorization: token },
          },
          { silent: true }
        );
        if (res?.success) setIsNewRecord(!!res.isNewRecord);
      } catch (e) {
        console.error(`${gameKey} save-score error:`, e);
      } finally {
        setSubmitting(false);
      }
    },
    [gameKey, userId, userCode, userName, token] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const fetchLeaderboard = useCallback(async () => {
    setLoadingLeaderboard(true);
    try {
      const res = await fetchData(
        { url: `/${gameKey}/leaderboard`, method: "post", headers: { Authorization: token } },
        { silent: true }
      );
      if (res?.success) setLeaderboard(res.leaderboard || []);
    } catch (e) {
      console.error(`${gameKey} leaderboard error:`, e);
    } finally {
      setLoadingLeaderboard(false);
    }
  }, [gameKey, token]); // eslint-disable-line react-hooks/exhaustive-deps

  return { submitting, isNewRecord, leaderboard, loadingLeaderboard, submitScore, fetchLeaderboard };
}
